import * as React from "react";
import { FunctionComponent } from "react";

export type Props = { sitename: string }

export const AckFooter: FunctionComponent<Props> = (props) => {
  return (
    <footer className="footer">
      <div className="columns">
        <div className="column has-text-left has-text-centered-mobile">
          <p className="is-small">Ackbox {props.sitename} @{new Date().getFullYear()} </p>
        </div>
        <div className="column is-2 has-text-right has-text-centered-mobile">
          <p className="is-small"><strong>Ackbox</strong></p>
        </div>
      </div>
    </footer>
  );
};
